var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBergLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "27px",
    viewBox: "0 0 69 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "emblem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(0.000000, -40.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "emblem",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8615,18.0342 L25.7165,18.1792 L25.8615,18.0342 Z",
    id: "Path",
    fill: "#006AB2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#006AB2",
    points: "25.8624 18.0342 34.4374 9.4592 34.4374 9.4582 34.4484 9.4472 25.7174 0.7152 17.1304 9.3022 25.8614 18.0342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F19400",
    points: "34.4377 9.4595 25.8627 18.0345 34.0547 26.2275 35.1337 26.2275 43.1697 18.1915"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#006AB2",
    points: "34.4377 9.4595 43.1697 18.1915 51.9017 9.4585 51.9017 9.4595 51.9027 9.4585 43.1697 0.7265 34.4487 9.4475 34.4377 9.4585"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F19400",
    points: "43.1701 18.1914 51.2061 26.2274 52.5981 26.2274 60.6341 18.1914 51.9011 9.4594 51.9011 9.4584"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9BE5C",
    points: "68.6711 26.227 60.6341 18.191 52.5981 26.227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F9BE5C",
    points: "25.8615 18.0342 25.7165 18.1792 17.6695 26.2272 34.0545 26.2272 25.8625 18.0342"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#0B71B4",
    points: "16.882 26.227 17.669 26.227 25.717 18.179 25.861 18.034 17.13 9.302 8.398 18.034 8.543 17.889"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#006AB2",
    points: "16.882 26.227 8.543 17.889 8.398 18.034 0.205 26.227"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBergLogo);
export default __webpack_public_path__ + "static/media/berg_logo.93ebedce.svg";
export { ForwardRef as ReactComponent };